import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Delete2"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.16335 1.6001H6.83608C6.19342 1.6001 5.67245 2.12108 5.67245 2.76373V3.34553H2.13667C1.84006 3.34553 1.59961 3.58598 1.59961 3.88259V4.55392C1.59961 4.85053 1.84006 5.09098 2.13667 5.09098H3.35139L3.44865 13.869C3.45191 14.1633 3.69139 14.4001 3.98568 14.4001H12.1231C12.4197 14.4001 12.6602 14.1597 12.6602 13.8631V5.09098H13.8625C14.1592 5.09098 14.3996 4.85053 14.3996 4.55392V3.88259C14.3996 3.58598 14.1592 3.34553 13.8625 3.34553H10.327V2.76373C10.327 2.12108 9.80601 1.6001 9.16335 1.6001ZM9.16337 3.34553V2.76368H6.8361V3.34553H9.16337ZM5.96497 6.70719H5.38277C5.222 6.70719 5.09167 6.8302 5.09167 6.98194V11.9274C5.09167 12.0791 5.222 12.2021 5.38277 12.2021H5.96497C6.12575 12.2021 6.25608 12.0791 6.25608 11.9274V6.98194C6.25608 6.8302 6.12575 6.70719 5.96497 6.70719ZM7.71162 6.70719H8.29382C8.45459 6.70719 8.58492 6.8302 8.58492 6.98194V11.9274C8.58492 12.0791 8.45459 12.2021 8.29382 12.2021H7.71162C7.55085 12.2021 7.42052 12.0791 7.42052 11.9274V6.98194C7.42052 6.8302 7.55085 6.70719 7.71162 6.70719ZM10.6227 6.70719H10.0405C9.8797 6.70719 9.74937 6.8302 9.74937 6.98194V11.9274C9.74937 12.0791 9.8797 12.2021 10.0405 12.2021H10.6227C10.7834 12.2021 10.9138 12.0791 10.9138 11.9274V6.98194C10.9138 6.8302 10.7834 6.70719 10.6227 6.70719Z",
  fill: "#A5ACBE"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var delete_2 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { delete_2 as default };
